if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.mediaItems = [];
        this.currentMediaIndex = 0;
        this.prevButton = this.querySelector('[data-product-modal-prev]');
        this.nextButton = this.querySelector('[data-product-modal-next]');

        if (this.prevButton) {
          this.prevButton.addEventListener('pointerup', (event) => event.stopPropagation());
          this.prevButton.addEventListener('click', this.showPreviousMedia.bind(this));
        }
        if (this.nextButton) {
          this.nextButton.addEventListener('pointerup', (event) => event.stopPropagation());
          this.nextButton.addEventListener('click', this.showNextMedia.bind(this));
        }

        this.addEventListener('keydown', this.onKeydown.bind(this));
      }

      hide() {
        this.querySelectorAll('[data-media-id].active').forEach((element) => element.classList.remove('active'));
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.syncMediaItems();
        this.showActiveMedia();
      }

      syncMediaItems() {
        this.mediaItems = Array.from(this.querySelectorAll('[role="document"] > [data-media-id]'));
      }

      showActiveMedia() {
        if (!this.mediaItems.length) return;

        const openerMediaId = this.openedBy && this.openedBy.getAttribute('data-media-id');
        const activeIndex = this.mediaItems.findIndex((item) => item.getAttribute('data-media-id') === openerMediaId);
        this.setActiveMedia(activeIndex >= 0 ? activeIndex : 0);
      }

      setActiveMedia(index) {
        if (!this.mediaItems.length) return;

        const mediaCount = this.mediaItems.length;
        this.currentMediaIndex = (index + mediaCount) % mediaCount;

        this.mediaItems.forEach((item, itemIndex) => {
          item.classList.toggle('active', itemIndex === this.currentMediaIndex);
        });

        const activeMedia = this.mediaItems[this.currentMediaIndex];
        if (!activeMedia) return;

        const container = this.querySelector('[role="document"]');
        if (container) {
          container.scrollTop = 0;
          container.scrollLeft = 0;
        }

        activeMedia.scrollIntoView({ block: 'nearest', inline: 'nearest' });

        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;

        if (activeMedia.nodeName === 'DEFERRED-MEDIA' && typeof activeMedia.loadContent === 'function') {
          activeMedia.loadContent();
        }

        if (
          activeMedia.nodeName === 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        ) {
          activeMedia.loadContent();
        }

        this.updateNavigationState();
      }

      showPreviousMedia() {
        this.setActiveMedia(this.currentMediaIndex - 1);
      }

      showNextMedia() {
        this.setActiveMedia(this.currentMediaIndex + 1);
      }

      updateNavigationState() {
        const hasMultipleMedia = this.mediaItems.length > 1;

        if (this.prevButton) {
          this.prevButton.toggleAttribute('hidden', !hasMultipleMedia);
          this.prevButton.disabled = !hasMultipleMedia;
        }

        if (this.nextButton) {
          this.nextButton.toggleAttribute('hidden', !hasMultipleMedia);
          this.nextButton.disabled = !hasMultipleMedia;
        }
      }

      onKeydown(event) {
        if (!this.hasAttribute('open')) return;

        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          this.showPreviousMedia();
        } else if (event.key === 'ArrowRight') {
          event.preventDefault();
          this.showNextMedia();
        }
      }
    }
  );
}
